export function getQueryString(name) {
  let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  let r = window.location.search.substr(1).match(reg);
  if (r != null) {
    return decodeURIComponent(r[2]);
  };
  return null;
}

export function checkParams() {
  // masterSn、opsBrand、sign、osName、opsModel、opsSn、masterModel、masterVersion 激活必须参数
  const masterSn = getQueryString('masterSn');
  const opsBrand = getQueryString('opsBrand');
  const sign = getQueryString('sign');
  const osName = getQueryString('opsModel');
  const opsModel = getQueryString('opsModel');
  const opsSn = getQueryString('opsSn');
  const masterModel = getQueryString('masterModel');
  const masterVersion = getQueryString('masterVersion');
  return !!(masterSn && opsBrand && sign && osName && opsModel && opsSn && masterModel && masterVersion);
}



// WEBPACK FOOTER //
// ./src/router/Interceptor.js